import { parseAsJson, useQueryState } from 'next-usequerystate'
import { useCallback, useMemo } from 'react'

import { OrderQuoteParams, SetOrderQuoteParams } from '../constants/order'
import { QueryParam } from '../constants/query'
import { parseOrderQuoteParams } from '../utils/order'

export default function useOrderQueryParams(): [OrderQuoteParams | null, SetOrderQuoteParams] {
  const [_orderParams, _setOrderParams] = useQueryState<OrderQuoteParams>(
    QueryParam.OrderParams,
    parseAsJson(parseOrderQuoteParams)
  )

  const orderParams = useMemo(() => parseOrderQuoteParams(_orderParams), [_orderParams])

  const setOrderParams: SetOrderQuoteParams = useCallback(
    (valueOrFunc) =>
      _setOrderParams(typeof valueOrFunc === 'function' ? valueOrFunc(orderParams) : valueOrFunc),
    [orderParams, _setOrderParams]
  )

  return useMemo(() => {
    return [orderParams, setOrderParams]
  }, [orderParams, setOrderParams])
}
